import { useState, useEffect } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Stepper,
  Step,
  StepLabel,
  IconButton,
} from "@material-ui/core";

import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import Api from "lib/api/httpRequestHelper";
import UtilsFncs from "utils/UtilsFncs";
import verifyProfilesVision from "utils/verifyProfilesVision";
import useStructureQueries from "hooks/useStructureQueries";
import ViewData from "./view-data";
import ViewAccess from "./view-access";
import { Close, Description } from "@mui/icons-material";

const DOCUMENT_TYPES = [
  { value: "MANUAL", label: "Manual" },
  { value: "PROCEDIMENTO", label: "Procedimento" },
  { value: "OUTROS", label: "Outros" },
];

const MEDIA_TYPES = [
  { value: "MIDIA", label: "Mídia" },
  { value: "LINK", label: "Link" },
  { value: "POPUP", label: "Modal" },
];

const FORM_TYPES = {
  CREATE: "create",
  EDIT: "edit",
  REMOVE: "remove",
};

export default function DialogCreateEdit({
  open,
  onClose,
  refresh,
  selectedRow,
  typeForm,
}) {
  const { getStores, getCategoriaList } = useStructureQueries();
  const [importando, setImportando] = useState(false);

  const [type, setType] = useState(
    selectedRow?.Tipo || DOCUMENT_TYPES[0].value
  );
  const [typeFile, setTypeFile] = useState(
    selectedRow?.TipoMidia || MEDIA_TYPES[0].value
  );
  const [title, setTitle] = useState(selectedRow?.Titulo || "");
  const [description, setDescription] = useState(selectedRow?.Descricao || "");
  const [extension, setExtension] = useState("");
  const [link, setLink] = useState("");
  const [filesToUpload, setFilesToUpload] = useState([]);
  const [notify, setNotify] = useState(selectedRow?.NotificaNoAcesso || false);
  const [aceite, setAceite] = useState(selectedRow?.AceiteDoUsuario || false);

  const [selectedBrands, setSelectedBrands] = useState([1, 2, 3]);
  const [selectedStoreIds, setSelectedStoreIds] = useState(
    selectedRow?.Pessoa || []
  );
  const [stores, setStores] = useState([]);
  const [storesLoading, setStoresLoading] = useState(false);

  const [categories, setCategories] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(
    selectedRow?.Categoria
  );

  const [selectedPerfilIds, setSelectedPerfilIds] = useState(
    selectedRow?.Perfis || []
  );

  const [activeStep, setActiveStep] = useState(0);
  const steps = ["Dados do Documento", "Liberação de Acesso"];

  const snackbar = useSnackbar();

  console.log("selectedRow", selectedRow);
  console.log("selectedPerfilIds", selectedPerfilIds);

  const resetForm = () => {
    setFilesToUpload([]);
    setDescription("");
    setExtension("");
    setTitle("");
    setType("");
    setSelectedStoreIds([]);
    setSelectedCategory(null);
    setSelectedPerfilIds([]);
    setActiveStep(0);
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleRefresh = () => {
    resetForm();
    refresh();
  };

  const deleteFile = async () => {
    try {
      const res = await Api.put(
        "edit-documents",
        "conteudo",
        {
          idDocumento: selectedRow?.IdDocumentoArea.toString(),
          ativo: "false",
        },
        true
      );
      if (res.Success) {
        snackbar.showMessage(`Arquivo excluído com sucesso!`, {
          severity: "success",
        });
        handleClose();
        handleRefresh();
      }
    } catch (error) {
      snackbar.showMessage(error, {
        severity: "error",
      });
    } finally {
      setImportando(false);
    }
  };

  const handleLinkDocument = async () => {
    const payload = {
      tipo: type,
      tipoMidia: typeFile,
      idCategoria: selectedCategory?.IdDocumentoAreaCategoria?.toString() || "",
      titulo: title,
      descricao: description,

      arquivo: link,
      extensao: link ? ".mp4" : extension ? extension : "",

      idsMarca: selectedBrands.join(","),
      idsLojas: selectedStoreIds.join(","),
      idsPerfis: selectedPerfilIds.join(","),

      notificaAcesso: notify,
    };

    if (typeForm === FORM_TYPES.EDIT) {
      payload.idDocumento = selectedRow?.IdDocumentoArea.toString();
      payload.ativo = "true";
    }

    const apiCall = typeForm === FORM_TYPES.EDIT ? Api.put : Api.post;
    const endpoint =
      typeForm === FORM_TYPES.EDIT ? "edit-documents" : "create-document";

    try {
      const res = await apiCall(endpoint, "conteudo", payload, true);
      if (res.Success) {
        snackbar.showMessage(
          typeForm === FORM_TYPES.EDIT
            ? "Documento atualizado com sucesso."
            : "Documento cadastrado com sucesso.",
          {
            severity: "success",
            autoHideDuration: 10000,
          }
        );
        handleClose();
        handleRefresh();
      }
    } catch (error) {
      snackbar.showMessage(error, {
        severity: "error",
        autoHideDuration: 10000,
      });
    } finally {
      setImportando(false);
    }
  };

  const handleFileUpload = async () => {
    const uploadPromises = filesToUpload.map(async (file) => {
      try {
        const base64Csv = await UtilsFncs.FileToB64(file);
        let encodedBase64 = base64Csv?.toString()?.replace(/^data:(.*,)?/, "");

        if (encodedBase64.length % 4 > 0) {
          encodedBase64 += "="?.repeat(4 - (encodedBase64.length % 4));
        }

        const payload = {
          tipo: type,
          tipoMidia: typeFile,
          idCategoria:
            selectedCategory?.IdDocumentoAreaCategoria?.toString() || "",
          titulo: title,
          descricao: description,
          notificaAcesso: notify,
          aceiteUser: aceite,

          arquivo: encodedBase64 ? encodedBase64 : "",
          extensao: extension ? extension : "",

          idsMarca: selectedBrands.join(","),
          idsLojas: selectedStoreIds.join(","),
          idsPerfis: selectedPerfilIds.join(","),
        };

        if (typeForm === FORM_TYPES.EDIT) {
          payload.idDocumento = selectedRow?.IdDocumentoArea.toString();
          payload.ativo = "true";
        }

        const apiCall = typeForm === FORM_TYPES.EDIT ? Api.put : Api.post;
        const endpoint =
          typeForm === FORM_TYPES.EDIT ? "edit-documents" : "create-document";

        const res = await apiCall(endpoint, "conteudo", payload, true);
        if (res.Success) {
          return {
            name: file.name,
            success: true,
          };
        }
      } catch (error) {
        snackbar.showMessage(error, {
          severity: "error",
          autoHideDuration: 10000,
        });
        return {
          name: file.name,
          error: "Não foi possível utilizar o arquivo formatado",
        };
      }
    });

    try {
      const returns = await Promise.all(uploadPromises);
      const filesWithError = returns.filter((file) => Boolean(file.error));

      if (filesWithError.length === 1) {
        snackbar.showMessage(filesWithError[0].error, {
          severity: "error",
        });
      } else {
        snackbar.showMessage(
          typeForm === FORM_TYPES.EDIT
            ? "Documento atualizado com sucesso."
            : "Documento cadastrado com sucesso.",
          {
            severity: "success",
            autoHideDuration: 10000,
          }
        );
        handleClose();
        handleRefresh();
      }
    } catch (error) {
      snackbar.showMessage(error, {
        severity: "error",
        autoHideDuration: 10000,
      });
    } finally {
      setImportando(false);
    }
  };

  const handleSendData = () => {
    setImportando(true);

    if (typeForm === FORM_TYPES.REMOVE) {
      return deleteFile();
    }

    if (typeFile === "LINK") {
      return handleLinkDocument();
    }

    return handleFileUpload();
  };

  const isStep1Valid = () => {
    if (!type || !description || !title || !selectedCategory) {
      return false;
    }

    if (typeFile === "MIDIA" || typeFile === "POPUP") {
      if (typeForm === FORM_TYPES.CREATE && filesToUpload.length === 0) {
        return false;
      }
    }

    if (typeFile === "LINK" && link === "") {
      return false;
    }

    return true;
  };

  const handleNext = () => {
    setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  const getDialogTitle = () => {
    switch (typeForm) {
      case FORM_TYPES.EDIT:
        return "Editar";
      case FORM_TYPES.REMOVE:
        return "Excluir";
      default:
        return "Adicionar";
    }
  };

  const getButtonText = () => {
    if (typeForm === FORM_TYPES.REMOVE) {
      return "Confirmar";
    }
    return typeForm === FORM_TYPES.CREATE ? "Confirmar" : "Atualizar";
  };

  useEffect(() => {
    if (filesToUpload?.length !== 0) {
      const fileName = filesToUpload[0]?.name;
      const index = fileName.lastIndexOf(".");
      const fileExtension = fileName.substring(index + 1);
      setExtension(fileExtension);
    }
  }, [filesToUpload]);

  useEffect(() => {
    if (selectedRow?.TipoMidia === "LINK") {
      setLink(selectedRow?.UrlArquivo);
    }
    if (selectedRow?.NomeArquivo) {
      setFilesToUpload([
        {
          name: selectedRow.NomeArquivo,
          url: selectedRow.UrlArquivo,
        },
      ]);
    }
  }, [selectedRow]);

  useEffect(() => {
    async function getCategories() {
      setCategoriesLoading(true);
      try {
        const result = await getCategoriaList();
        const res = result?.data ?? {};
        setCategories(res.Categorias || []);
      } catch (error) {
        snackbar.showMessage(error?.toString() || "Erro ao buscar categorias", {
          severity: "error",
        });
      } finally {
        setCategoriesLoading(false);
      }
    }
    getCategories();
  }, [getCategoriaList]);

  useEffect(() => {
    const isFranquia = verifyProfilesVision([
      "FRANQUEADO_ADM",
      "FRANQUIAS_ADM",
    ]);

    async function getStoresFranquia() {
      setStoresLoading(true);
      try {
        const response = await Api.get(
          "list-economic-groups",
          "franquias",
          "?idCanal=6",
          true
        );

        if (response?.Result?.Items) {
          const allStoresFormatted = response.Result.Items.reduce(
            (acc, item) => {
              if (item.Lojas && item.Lojas.length > 0) {
                const storesFormatted = item.Lojas.map((loja) => ({
                  IdLoja: loja.IdPessoa,
                  Nome: loja.Nome,
                  Apelido: loja.Apelido,
                  CNPJ: loja.CnpjCpf,
                }));
                return [...acc, ...storesFormatted];
              }
              return acc;
            },
            []
          );
          setStores(allStoresFormatted);
        }
      } catch (error) {
        snackbar.showMessage(error?.toString() || "Erro ao buscar lojas", {
          severity: "error",
        });
      } finally {
        setStoresLoading(false);
      }
    }

    async function loadStores() {
      setStoresLoading(true);
      try {
        const promises = selectedBrands.map((brandId) =>
          getStores({ idMarca: brandId })
        );
        const responses = await Promise.all(promises);

        const allStores = [];
        const storeIds = new Set();

        responses.forEach((result) => {
          const resultList = result?.data ?? [];
          if (Array.isArray(resultList)) {
            resultList.forEach((loja) => {
              if (!storeIds.has(loja.Id)) {
                storeIds.add(loja.Id);
                allStores.push({
                  IdLoja: loja.Id,
                  Nome: loja.Nome,
                  Apelido: loja.Apelido,
                  CNPJ: (loja.CNPJ || "").replace(/\D/g, ""),
                  Sigla: loja.Sigla,
                  IdFilialEmpresa: loja.IdFilialEmpresa,
                });
              }
            });
          }
        });

        setStores(allStores);
      } catch (error) {
        snackbar.showMessage(error?.toString() || "Erro ao buscar lojas", {
          severity: "error",
        });
      } finally {
        setStoresLoading(false);
      }
    }

    if (isFranquia) {
      getStoresFranquia();
    } else {
      loadStores();
    }
  }, [selectedBrands, getStores]);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md">
      <DialogTitle>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h3" color="primary">
            <Description style={{ marginRight: "12px" }} />
            {`${getDialogTitle()} Manuais`}
          </Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </div>
      </DialogTitle>

      {typeForm !== FORM_TYPES.REMOVE && (
        <Stepper
          activeStep={activeStep}
          alternativeLabel
          style={{ paddingTop: "0" }}
        >
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>
      )}

      <DialogContent>
        {typeForm === FORM_TYPES.REMOVE ? (
          <Typography id="alert-dialog-description" variant="h4">
            Confirmar exclusão do arquivo?
          </Typography>
        ) : (
          <>
            {activeStep === 0 && (
              <ViewData
                type={type}
                setType={setType}
                typeFile={typeFile}
                setTypeFile={setTypeFile}
                categories={categories}
                categoriesLoading={categoriesLoading}
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
                title={title}
                setTitle={setTitle}
                description={description}
                setDescription={setDescription}
                link={link}
                setLink={setLink}
                setFilesToUpload={setFilesToUpload}
                notify={notify}
                setNotify={setNotify}
                aceite={aceite}
                setAceite={setAceite}
                disabled={importando}
              />
            )}
            {activeStep === 1 && (
              <ViewAccess
                selectedBrands={selectedBrands}
                setSelectedBrands={setSelectedBrands}
                stores={stores}
                storesLoading={storesLoading}
                selectedStoreIds={selectedStoreIds}
                setSelectedStoreIds={setSelectedStoreIds}
                selectedPerfilIds={selectedPerfilIds}
                setSelectedPerfilIds={setSelectedPerfilIds}
              />
            )}
          </>
        )}
      </DialogContent>

      <DialogActions>
        {typeForm !== FORM_TYPES.REMOVE && activeStep > 0 && (
          <Button
            variant="outlined"
            onClick={handleBack}
            style={{ marginRight: "0.5rem" }}
          >
            Voltar
          </Button>
        )}
        {typeForm === FORM_TYPES.REMOVE ? (
          <Button
            variant="contained"
            onClick={handleSendData}
            disabled={importando}
          >
            {getButtonText()}
          </Button>
        ) : activeStep === steps.length - 1 ? (
          <Button
            variant="contained"
            onClick={handleSendData}
            disabled={!(isStep1Valid() && !importando)}
          >
            {getButtonText()}
          </Button>
        ) : (
          <Button
            variant="contained"
            color="primary"
            onClick={handleNext}
            disabled={!isStep1Valid()}
          >
            Próximo
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
